export enum OccupationCategory {
	PermanentEmployee = 'PermanentEmployee',
	SelfEmployed = 'SelfEmployed',
	IndependentProfessional = 'IndependentProfessional',
	Retired = 'Retired',
	TemporaryEmployee = 'TemporaryEmployee',
	NoStableIncome = 'NoStableIncome',
}
